import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';

import ProFeaturePlaceholder
  from 'components/common/ProFeaturePlaceholder';

import './PublicPageLayoutSelector.css';

const PublicPageLayoutSelector = ({ me, patchUser }) => {
  const onModeChange = value => {
    const form = new FormData();
    form.append('page_layout', value);
    patchUser(form);
  };
  const { t } = useTranslation();

  return (
    <div className="public-page-layout-selector__component">
      <div className="title">{t("Select a layout of your HeyLink.me")}</div>
      <div className="wrapper">
        <div
          className={`mode${me.page_layout === 'avatar' ? ' active' : ''}`}
          onClick={() => onModeChange('avatar')}
          role="button"
          tabIndex={-1}
        >
          <div className="checked-icon" />
          <div className="image avatar" />
          <div className="subtext">{t("Avatar")}</div>
        </div>

        <ProFeaturePlaceholder
          proLabel
          key="cover-page-layout-pro-feature-key"
          placeholderContent={<>{t("Cover Image is available on the PRO plan.")}</>}
          locked={me && me.subscription && !me.subscription.ff_cover}
        >
          <div
            className={`mode${me.page_layout === 'cover' ? ' active' : ''}`}
            onClick={() => onModeChange('cover')}
            role="button"
            tabIndex={-1}
          >
            <div className="checked-icon" />
            <div className="image cover-image" />
            <div className="subtext">{t("Cover Image")}</div>
          </div>
        </ProFeaturePlaceholder>
      </div>
    </div>
  );
};

PublicPageLayoutSelector.propTypes = {
  patchUser: PropTypes.func.isRequired,
  me: PropTypes.object,
};

PublicPageLayoutSelector.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(PublicPageLayoutSelector);
